import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { MinimumStation, Station } from '@mi-front/core';
import { AxisLeft } from '@visx/axis';
import { TimelineStationTickLabel } from '../axis/TimelineStationTickLabel';
import { TimelineChartYScale } from '../lib/timeline-chart-scale-types';

type StationsFinder = ReturnType<typeof useStationsFinder>;

export type TimelineChartStationAxisProps = {
  yScale: TimelineChartYScale;
  stationIds: string[];
  hoveredStationId: string | null;
  finder: StationsFinder;
};

/**
 * Left axis: station ids with optional bold name when a row bar is hovered.
 */
export function TimelineChartStationAxis({
  yScale,
  stationIds,
  hoveredStationId,
  finder,
}: TimelineChartStationAxisProps) {
  return (
    <AxisLeft
      scale={yScale}
      stroke="transparent"
      tickStroke="transparent"
      tickValues={stationIds}
      tickFormat={(stationId) => String(stationId)}
      tickLabelProps={() => ({})}
      tickComponent={(tickProps) => {
        const stationId = tickProps.formattedValue;
        if (!stationId) {
          return null;
        }
        const station = resolveStationLabel(finder, stationId);
        return (
          <TimelineStationTickLabel
            anchorX={tickProps.x}
            anchorY={tickProps.y}
            nameEmphasized={hoveredStationId === stationId}
            station={station}
          />
        );
      }}
    />
  );
}

function resolveStationLabel(finder: StationsFinder, stationId: string): Station | MinimumStation {
  return finder(stationId) ?? { id: stationId, name: stationId, slug: stationId };
}
